<template>
  <div class="add-material-modal">
    <q-form @submit="onSubmit" class="modal-form">
      <div class="modal-content">
        <div class="form-field">
          <CustomInput label="Цена" placeholder="Введите..." :value="formData.price_whole"
            @change_input="value => onChange('price_whole', value)" required :showClearIcon="false" :max="100000000" />
        </div>

        <div class="form-date-fields">
          <div class="form-field">
            <CustomDate :required="true" placeholder="Период дата начала" :value="this.formData.date_begin || ''"
              @change_date="value => onChange('date_begin', value)" :fullWidth="true" />
          </div>

          <div class="form-field">
            <CustomDate placeholder="Период дата окончания" :value="this.formData.date_end || ''"
              @change_date="value => onChange('date_end', value)" :fullWidth="true" />
          </div>
        </div>
      </div>
      <CustomModalFooter :btn-loading="loading" />
    </q-form>
  </div>
</template>

<script>
import CustomButton from '@/components/common/CustomButton'
import CustomIcon from '@/components/common/CustomIcon'
import SvgIcon from '@/components/common/SvgIcon'
import CustomCheckbox from '@/components/form/CustomCheckbox'
import CustomDate from '@/components/form/CustomDate'
import CustomInput from '@/components/form/CustomInput'
import CustomSelect from '@/components/form/CustomSelect'
import CustomModalFooter from '@/components/modal/modals/modal-footer'

export default {
  name: 'add-material-provider-price',
  components: {
    CustomInput,
    CustomSelect,
    CustomButton,
    CustomDate,
    SvgIcon,
    CustomIcon,
    CustomModalFooter,
    CustomCheckbox,
  },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        material_provider_id: this.data?.body?.material_provider_id || '',
        date_begin: this.data?.body?.date_begin || '',
        date_end: this.data?.body?.date_end || '',
        price_whole: this.data?.body?.price_whole || '',
      },
      materialTypes: [],
      unitOptions: [],
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    onCancel() {
      if (this.data?.onCancel) {
        this.data.onCancel()
      }
    },
    async onSubmit() {
      if (!this.formData.date_begin || !this.formData.price_whole) {
        return
      }
      this.loading = true

      const payload = {
        material_provider_id: this.formData.material_provider_id,
        date_begin: this.formData.date_begin,
        date_end: this.formData.date_end || null,
        price_whole: this.formData.price_whole,
      }

      if (this.data?.onSubmit) {
        await this.data.onSubmit(payload)
      }

      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
.add-material-modal {
  max-width: 627px;
  width: 100%;
}

.modal-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-date-fields {
  display: flex;
  gap: 16px;
}

.form-field {
  width: 100%;

  :deep(.q-checkbox__label) {
    color: #373d48;
    font-size: 14px;
  }
}

.field-label {
  display: block;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.29;
  color: #000000;
  margin-bottom: 8px;
}

.units-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px;
  background: #f2f5f8;
  border-radius: 8px;
}

.units-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
}

.unit-group {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.arrow-icon {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #9ca3af;
  border-radius: 50%;
  width: 24px;
  height: 24px;

  .q-icon {
    width: 24px;
    height: 24px;
  }
}

@media (max-width: 768px) {
  .add-material-modal {
    max-width: 100%;
  }

  .modal-footer {
    width: 100%;
  }

  .units-row {
    flex-direction: column;
    align-items: stretch;
  }

  .arrow-icon {
    transform: rotate(90deg);
    padding: 8px 0;
  }
}
</style>
